import { render, staticRenderFns } from "./ModelInTable.vue?vue&type=template&id=424f6a1a&scoped=true"
import script from "./ModelInTable.vue?vue&type=script&lang=js"
export * from "./ModelInTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f6a1a",
  null
  
)

export default component.exports